import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Grid, Typography, FormControlLabel, Checkbox } from '@material-ui/core'
import { withRouter } from 'react-router'

import ViewToggle from './ViewToggle'
import PropertyCard from './PropertyCard'
import PropertyRow from './PropertyRow'
import SaveSearch from 'features/savedSearches/components/SaveSearch'
import Paginator from './Paginator'
import Loader from './Loader'
import NoPropertyFound from './NoPropertyFound'
import * as actions from '../actions'
import * as types from '../constants'
import { isUserLogged, filteredProperties } from 'utils'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'
import { Grow, ClickAwayListener, Paper, Popper, MenuItem, MenuList } from '@material-ui/core'
import Button from 'components/ButtonMaterial'
import settingIcon from 'images/settings-icon.png'

const classNames = require('classnames')
const sortDesc = 'desc'
const sortAsc = 'asc'
const filterOptions = {
  sqft: 'Sqft',
  beds: 'Beds',
  baths: 'Baths',
  price: 'Price',
  homeType: 'Home',
  type: 'Property',
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    padding: '15px 0px',
    [theme.breakpoints.down('xs')]: {
      padding: '15px 20px',
    },
  },
  propertiesRoot: {
    padding: '0',
    width: 'auto',
    maxWidth: '1240px',
    margin: '0 auto',
    [theme.breakpoints.down('1356')]: {
      maxWidth: '930px',
    },
    [theme.breakpoints.down('1046')]: {
      maxWidth: '620px',
    },
    [theme.breakpoints.down('736')]: {
      maxWidth: '310px',
    },
  },
  flexHcenter: {
    display: 'flex',
    alignItems: 'center',
  },
  gridList: {
    width: '100%',
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  listingTitle: {
    fontSize: 28,
    letterSpacing: '-0.5px',
    color: '#2d3447',
    marginBottom: 30,
    lineHeight: 1,
  },
  listRowHead: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: '400',
    color: '#838383',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listRow: {
    width: '100%',
    height: '49px',
    padding: '0',
    margin: '0px !important',
    display: 'flex',
    alignItems: 'stretch',
    '&:nth-child(odd)': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#ffffff',
        boxShadow: '0 7px 23px 0 rgba(0, 0, 0, 0.04)',
      },
    },
    '&:nth-child(even)': {
      backgroundColor: 'rgba(0, 188, 181, 0.05)',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'rgba(0, 188, 181, 0.16)',
      },
    },
  },
  listLink: {
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: '0 15px',
    fontSize: 0,
    width: '100%',
    textDecoration: 'none',
  },
  gridLink: {
    outline: 'none',
    display: 'block',
    margin: '0',
    fontSize: 0,
    '&:hover': {
      boxShadow: '0 7px 23px rgba(0,0,0,0.14), 0 10px 10px rgba(0,0,0,0.04)',
    },
  },
  propertySmallCard: {
    margin: '10px',
  },
  cardWrapper: {
    width: 'calc(100% - -20px)',
    margin: '-10px',
  },
  heading2: {
    fontSize: '28px',
    fontWeight: '500',
    letterSpacing: '-0.4px',
    color: '#2d3447',
    margin: '0 0 30px',
  },
  propertyRoot: {
    padding: '0',
    maxWidth: '1366px',
    margin: '0 auto',
  },
  gridListContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 0 25px',
    alignItems: 'center',
  },
  gridListContentCount: {
    margin: '0 0 15px',
  },
  typographyCaption: {
    fontSize: '14px',
    color: '#333645',
    display: 'inline-block',
  },
  listRowHeadContent: {
    width: '50%',
  },
  gridListItems: {
    padding: '10px 15px',
  },
  listRowHeadItem: {
    width: '12%',
  },
  alignCenter: {
    alignItems: 'center',
  },
  listRowHeadItem2: {
    width: '11%',
  },
  listRowHeadItem3: {
    width: '15%',
  },
  listRowHeadItem4: {
    width: '5%',
  },

  settingIcon: {
    width: '22px',
    opacity: '0.7',
    transform: 'rotate(45deg)',
    height: '22px',
    position: 'relative',
    left: '1px',
  },

  settingButton: {
    margin: '0 0 0 auto',
    height: '30px',
    background: '#fff',
    color: '#000',
    padding: '0',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.15)',
    width: '46px !important',
    minWidth: 'inherit',

    '&:hover': {
      color: '#000',
      backgroundColor: '#fff',
    },

    '& svg': {
      opacity: '0.5',
      fontSize: '18px',
    },
  },

  menuListToggle: {
    width: '240px',
    zIndex: '20',
    boxSizing: 'border-box',
    margin: '2px 0 0',
  },

  menuList: {
    maxHeight: '365px',
    overflow: 'auto',
    margin: '15px 0 30px',
    padding: '0',

    '& li': {
      '&:hover': {
        backgroundColor: 'transparent',
      },

      '&:focus': {
        backgroundColor: 'transparent',
      },
    },

    [theme.breakpoints.down('xs')]: {
      margin: '15px 0',
      maxHeight: '170px',
    },

    '& span:nth-child(2)': {
      color: '#333645',
      fontSize: '16px',
      margin: '0 0 0 5px',
    },
  },

  menuPaperContainer: {
    padding: '20px 20px 25px',
    boxShadow: '0 0 25px rgba(0, 0, 0, 0.04)',
  },

  menuPaperTitle: {
    margin: '0',
    padding: '0',
    color: '#333645',
    fontSize: '21px',
    fontWeight: '500',
  },

  menuPaperInfo: {
    margin: '0',
    padding: '0',
    fontSize: '13px',
    color: '#838383',
  },

  applyButton: {
    width: '100%',
    fontSize: '18px',
    fontWeight: '500',
    marginTop: '0',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    '&:hover': {
      backgroundColor: '#00bcb5 !important',
    },
  },

  settingRoot: {
    color: 'rgba(0, 0, 0, 0.15)',
    padding: '0',
  },

  settingChecked: {
    color: '#00bcb5 !important',
  },

  sortRow: {
    display: 'inline-block',
    margin: '0 0 0 3px',
    position: 'relative',
    top: '1px',

    '& span': {
      width: '0',
      height: '0',
      marginTop: '1px',
      opacity: '0.4',
      display: 'block',
      cursor: 'pointer',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
    },
  },

  sortAsc: {
    borderBottom: '5px solid black',
  },

  sortDesc: {
    borderTop: '5px solid black',
  },
})

class Properties extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isGridView: true,
      activePage: 1,
      menuOpen: false,
      listOptions: {
        sqft: true,
        beds: true,
        baths: true,
        price: true,
        homeType: false,
        type: false,
      },
      columns: [],
      colKeys: [],
      sortOrders: {
        sqft: sortDesc,
        beds: sortDesc,
        baths: sortDesc,
        price: sortDesc,
        homeType: sortDesc,
        type: sortDesc,
      },
    }
    this.handler = this.handler.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { properties, offset, count } = this.props
    if (!this.props.isAdcFr && !properties.equals(prevProps.properties) && offset === 0) {
      this.setState({
        activePage: 1,
      })
    }
    // set the pagination to previous page in case count has reduced when property was flagged
    if (!properties.equals(prevProps.properties) && count < prevProps.count) {
      const active = this.state.activePage
      const pageSize = parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE, 10)
      if (count <= (active - 1) * pageSize) {
        this.setState({
          activePage: active - 1 >= 1 ? active - 1 : 1,
        })
      }
    }
  }

  componentDidMount() {
    this.customiseColumn()
  }

  handler(bool) {
    this.setState({
      isGridView: bool,
    })
  }

  toggleFilters() {
    this.props.actions.toggleFilters()
  }

  selectPage(page) {
    const { properties, actions, user } = this.props
    const filteredProps = filteredProperties(properties)
    let displayProps = isUserLogged(user) ? properties : filteredProps
    const pageSize = parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE, 10)
    this.setState({
      activePage: page,
    })
    if (displayProps.size < page * pageSize) {
      actions.fetchPropertiesPage()
    }
  }

  highlightedBoxShadow = propertyId =>
    this.state.isGridView && Number(propertyId) === this.props.selected ? '0 7px 23px rgba(0, 0, 0, 0.14), 0 10px 10px rgba(0, 0, 0, 0.04)' : 'none'

  handleToggleMenu = () => this.setState(prevState => ({ menuOpen: !prevState.menuOpen }))

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return
    }
    this.setState({ menuOpen: false })
    this.setState({
      listOptions: {
        sqft: false,
        beds: false,
        baths: false,
        price: false,
        homeType: false,
        type: false,
      },
    })
    this.state.colKeys.map(key => this.setState(state => ({ listOptions: { ...state.listOptions, [key]: true } })))
  }

  handleChange = name => {
    this.setState(state => ({
      listOptions: { ...state.listOptions, [name]: !state.listOptions[name] },
    }))
  }

  isValid = () => {
    const { listOptions } = this.state
    return Object.keys(listOptions).filter(item => listOptions[item] === true).length === 4
  }

  handleSorting = sortByVal => {
    const { sortOrders } = this.state
    const sortOrderVal = sortOrders[sortByVal]
    if (sortByVal && sortOrderVal) {
      this.props.actions.handleSorting(sortByVal, sortOrderVal).then(() => {})
    }
    this.setState(prevState => ({
      sortOrders: {
        ...prevState.sortOrders,
        [sortByVal]: sortOrderVal === sortDesc ? sortAsc : sortDesc,
      },
    }))
  }

  customiseColumn = () => {
    const { classes } = this.props
    const { listOptions } = this.state
    const columnItems = Object.keys(listOptions)
      .filter(item => listOptions[item] === true)
      .map((item, index) => (
        <Grid className={classes.listRowHeadItem} item key={`column-${index}`}>
          <span className={classes.alignCenter}>{filterOptions[item]}</span>
          <span className={classes.sortRow} onClick={() => this.handleSorting(item)}>
            <span className={classes.sortAsc} />
            <span className={classes.sortDesc} />
          </span>
        </Grid>
      ))
    this.setState({
      columns: columnItems,
      colKeys: Object.keys(listOptions).filter(item => listOptions[item] === true),
      menuOpen: false,
    })
  }

  render() {
    const { isLoading, classes, isAdcFr, sortOrder, properties, user, count, className } = this.props
    const sortBy = this.props.sortBy === 'date' ? 'id' : this.props.sortBy
    let { activePage, columns, colKeys } = this.state
    const pageSize = parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE, 10)
    const filteredProps = filteredProperties(properties)
    let displayProps = isUserLogged(user) ? properties : filteredProps
    let displayCount = displayProps.size
    activePage = !isUserLogged(user) && activePage > 1 && displayCount < pageSize * (activePage - 1) ? 1 : activePage
    let isGridView = this.state.isGridView,
      from = (activePage - 1) * pageSize,
      to = from + pageSize
    let CompName = isAdcFr || isGridView ? PropertyCard : PropertyRow
    let gridOrListClasses = classNames({
      [classes.gridView]: isGridView,
      [classes.listView]: !isGridView,
    })

    let cardOrRowClasses = classNames({
      'grid-card': isGridView,
      [classes.listRow]: !isGridView,
      'small-grid-card': true,
      [classes.propertySmallCard]: true,
    })

    let gridOrListLink = classNames({
      [classes.gridLink]: isGridView,
      [classes.listLink]: !isGridView,
    })

    const menuItems = Object.keys(filterOptions).map((item, index) => {
      return (
        <MenuItem className={classes.logoutLink} key={`menu-index=${index}`}>
          <FormControlLabel
            className={classes.filterChecklabel}
            key={index}
            control={
              <Checkbox
                value={item}
                onChange={() => this.handleChange(item)}
                checked={this.state.listOptions[item] === true}
                classes={{
                  root: classes.settingRoot,
                  checked: classes.settingChecked,
                }}
              />
            }
            label={item === 'homeType' || item === 'type' ? `${filterOptions[item]} Type` : filterOptions[item]}
          />
        </MenuItem>
      )
    })

    return (
      <div className={`${classes.root} ${classes.propertyRoot} ${className}`}>
        <Grid container className={gridOrListClasses}>
          {isAdcFr ? (
            <Grid className={classes.gridListContent}>
              <h2 className={classes.heading2}>Active Listings{displayCount ? ` (${displayCount})` : ''}</h2>
            </Grid>
          ) : (
            !!displayCount && (
              <Grid container alignItems="center" justify="space-between" className={classes.gridListContentCount}>
                <Grid item>
                  <Typography className={classes.typographyCaption} variant="caption">
                    {!isLoading && `${displayCount} result${displayCount === 1 ? '' : 's'} found.`}
                  </Typography>

                  <SaveSearch user={user} />
                </Grid>
                {!isGridView && (
                  <Button
                    buttonRef={node => {
                      this.anchorEl = node
                    }}
                    style={{ width: '10%' }}
                    aria-owns={this.state.menuOpen ? 'menu-list-grow' : null}
                    aria-haspopup="true"
                    onClick={this.handleToggleMenu}
                    className={classes.settingButton}>
                    <span className={classes.settingIcon}>
                      <img src={settingIcon} alt={'setting_Icon'} className={classes.settingIcon} />
                    </span>
                    {this.state.menuOpen ? <ArrowDropUp /> : <ArrowDropDown />}
                  </Button>
                )}
                <Popper open={this.state.menuOpen} anchorEl={this.anchorEl} transition disablePortal placement="top-end" className={classes.menuListToggle}>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      id="menu-list-grow"
                      style={{
                        transformOrigin: placement === 'top-end' ? 'center top' : 'center bottom',
                      }}>
                      <ClickAwayListener onClickAway={this.handleClose}>
                        <Paper className={classes.menuPaperContainer}>
                          <div className={classes.menuTitle}>
                            <h4 className={classes.menuPaperTitle}>Show Columns</h4>
                            <p className={classes.menuPaperInfo}>Select 4</p>
                          </div>
                          <MenuList className={classes.menuList}>{menuItems}</MenuList>

                          <Button disabled={!this.isValid()} className={classes.applyButton} onClick={this.customiseColumn}>
                            Apply
                          </Button>
                        </Paper>
                      </ClickAwayListener>
                    </Grow>
                  )}
                </Popper>
                <ViewToggle handler={this.handler} isGridView={isGridView} />
              </Grid>
            )
          )}
          {isLoading ? (
            isAdcFr ? (
              <Loader />
            ) : (
              // 100vh is for viewport height,
              // 64px is header height,
              // 64px is filter-bar height
              // 60px is for maintaining scroll whenever loader component appears
              // 42px is the padding sorrounding the parent of loader/no-result section / property result
              <Loader style={{ height: 'calc(100vh - (64px + 64px + 60px + 42px))' }} />
            )
          ) : displayCount ? (
            <Fragment>
              <Grid container className={isGridView ? classes.cardWrapper : ''}>
                {!isGridView ? (
                  <Grid className={classes.gridListItems} item xs={12}>
                    <Grid container className={classes.listRowHead}>
                      <Grid className={classes.listRowHeadContent} item>
                        <span>Address</span>
                        {/* <span className={classes.sortRow}>
                          <span onClick={() => this.handleSorting(`address_asc`)} className={classes.sortAsc} />
                          <span onClick={() => this.handleSorting(`address_desc`)} className={classes.sortDesc} />
                        </span> */}
                      </Grid>
                      {/* <Grid className={classes.listRowHeadItem} item>
                        <span className={classes.alignCenter}>Sqft</span>
                      </Grid>
                      <Grid item className={classes.listRowHeadItem}>
                        <span className={classes.alignCenter}>BD</span>
                      </Grid>
                      <Grid className={classes.listRowHeadItem2} item>
                        <span className={classes.alignCenter}>BA</span>
                      </Grid>
                      <Grid item className={classes.listRowHeadItem3}>
                        <span className={classes.alignCenter}>Price</span>
                      </Grid> */}
                      {columns}
                      <Grid item className={classes.listRowHeadItem4}>
                        <span />
                      </Grid>
                    </Grid>
                  </Grid>
                ) : null}
                {displayProps
                  .toList()
                  .sort((a, b) =>
                    sortBy === 'homeType' || sortBy === 'type'
                      ? sortOrder === 'desc'
                        ? (b[sortBy] || '').localeCompare(a[sortBy] || '')
                        : (a[sortBy] || '').localeCompare(b[sortBy] || '')
                      : sortOrder === 'desc'
                      ? b[sortBy] - a[sortBy]
                      : a[sortBy] - b[sortBy]
                  )
                  .slice(from, to)
                  .map((p, ix) => (
                    <Grid item key={`card_${ix}`} value={p} className={cardOrRowClasses}>
                      <Link
                        to={isAdcFr ? `/details/${p.id}` : `${types.ROUTES_PATH.PROPERTY}/${p.id}?${this.props.searchString}`}
                        onClick={() => {
                          this.props.onSelect()
                        }}
                        className={gridOrListLink}
                        style={{
                          boxShadow: this.highlightedBoxShadow(p.id),
                        }}>
                        <CompName key={`prop_${ix}`} property={p} cardPlacement listOptions={colKeys} />
                      </Link>
                    </Grid>
                  ))}
              </Grid>
              <Paginator pageSize={pageSize} totalItems={displayCount} onSelect={page => this.selectPage(page)} activePage={activePage} numLinks={5} />
            </Fragment>
          ) : (
            count === 0 && (
              <Fragment>
                {isAdcFr ? (
                  <NoPropertyFound />
                ) : (
                  <React.Fragment>
                    <SaveSearch user={user} /> <NoPropertyFound msg={`${types.MESSAGE.NO_RESULTS_FOUND.PROPERTIES_SEARCH.MSG}`} />{' '}
                  </React.Fragment>
                )}
              </Fragment>
            )
          )}
        </Grid>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    properties: state.properties.get('data'),
    offset: state.properties.get('offset'),
    isLoading: state.properties.get('isLoading'),
    searchLocation: state.properties.get('loc'),
    queryAddress: state.properties.get('queryAddress'),
    count: state.properties.get('count'),
    selected: state.properties.get('selected'),
    isFilterApplied: state.filters.isFilterApplied,
    sortBy: state.filters.sortBy,
    sortOrder: state.filters.sortOrder,
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const properties = withStyles(styles)(withRouter(Properties))
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(properties)



// WEBPACK FOOTER //
// ./src/components/Properties.js